import { Box } from '../Layout'
import { Spinner } from './mui'

export function FullPageSpinner() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 20 }}>
      <Spinner size={120} />
    </Box>
  )
}
